import PropTypes from 'prop-types';
import React from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from '@material-ui/core/styles';
import type { Theme } from 'src/theme';

const SingleValue = (props) => {
  const theme: Theme = useTheme();
  return (<ContentLoader
    speed={2}
    width={props.width || '100%'}
    height={props.height || 10}
    // viewBox="0 0 400 160"
    backgroundColor={theme.customs.loader.background}
    foregroundColor={theme.customs.loader.foreground}
    {...props}
  >
    <rect x="0" y="0" rx="3" ry="3" width={props.valueWidth || '100%'} height={props.valueHeight || 6} />
  </ContentLoader>);
};

SingleValue.propTypes = {
  height: PropTypes.number,
  valueHeight: PropTypes.number,
  valueWidth: PropTypes.string,
  width: PropTypes.string
};

export default SingleValue;
